module.exports = __webpack_public_path__ + "images/iphone/pld_logo.png";